"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Snackbar_1 = require("../../components/Snackbar");
const ErrorAlert = ({ error, severity = "error", onClose, retry, }) => {
    // There are some errors that we want to ignore, so we add them a field called ignore
    // If the field is true, we should ignore them
    if (!error || error.name === "ignore")
        return null;
    return (react_1.default.createElement(Snackbar_1.SnackBar, { message: error.message, buttonText: retry ? "Retry" : "", type: "alert", onClick: () => {
            if (retry)
                retry();
            onClose();
        }, onClose: onClose, severity: severity }));
};
exports.default = ErrorAlert;
